import React               from 'react';
import { observer }        from 'mobx-react-lite';
import View                from '@widesk-ui/components/View';
import ButtonActions       from '@widesk-ui/components/ButtonActions';
import { LogoutOutlined }  from '@ant-design/icons';
import { UserOutlined }    from '@ant-design/icons';
import { useAuth }         from '@widesk-ui/hooks/useAuth';
import { navigate }        from '@widesk-ui/hooks/useNavigate';
import { MY_ACCOUNT_PATH } from '@/routes/private/myAccountRoute';

// `ButtonActions` sépare icône et libellé par un simple espace : on ajoute une marge sur l'icône
// pour un espacement plus net dans ce menu. Repris de `LayoutHeader`, dont ce menu est le pendant.
const menuIcon = (icon: React.ReactNode) => <span style={{ marginRight: 6 }}>{icon}</span>;

/**
 * Compte courant et déconnexion, jusqu'ici inaccessibles depuis l'éditeur : il remplace la barre du
 * back-office par la sienne, et se déconnecter imposait donc d'en sortir d'abord.
 *
 * Mêmes entrées, mêmes libellés et même confirmation que le menu de `LayoutHeader` — c'est le même
 * geste, il ne doit pas se faire autrement d'un écran à l'autre.
 */
const UserMenu = observer(() => {
	const { logout } = useAuth();

	return (
		<View className="header-user-settings" center>
			<ButtonActions
				actions={[
					{
						label: 'Informations du compte',
						icon: menuIcon(<UserOutlined />),
						onClick: () => navigate(MY_ACCOUNT_PATH),
					},
					{
						label: 'Déconnexion',
						icon: menuIcon(<LogoutOutlined />),
						danger: true,
						confirm: 'Voulez-vous vraiment vous déconnecter ?',
						onClick: () => logout(),
					},
				]}
				// Bouton rond, comme `ThemeToggleButton` et les autres actions de cette barre, et surtout
				// PAS un avatar : il en jouxte une rangée (voir `Users`), où un avatar signifie "telle
				// personne est présente". Deux objets identiques pour deux sens différents se lisaient mal.
				icon={(
					<View
						h={42}
						w={42}
						color="white"
						center
						style={{ borderRadius: '50%' }}
						hover={{ bg: '#393A40' }}
					>
						<UserOutlined style={{ fontSize: 18 }} />
					</View>
				)}
				type="text"
				// Le bouton d'AntD ajoute sa propre boîte autour du contenu : sans ça, sa hauteur et son
				// padding décalaient le cercle et le faisaient dépasser des autres actions de la barre.
				// Il se réduit ici exactement au cercle, qui porte seul la taille et le survol.
				style={{ padding: 0, width: 42, height: 42, border: 'none', background: 'transparent' }}
			/>
		</View>
	);
});

export default UserMenu;
